import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AuthGuard from './components/AuthGuard';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import EmailVerification from './pages/EmailVerification';
import EmailConfirmed from './pages/EmailConfirmed';
import PasswordResetRequest from './pages/PasswordResetRequest';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Settings from './pages/Settings';
import Rewards from './pages/Rewards';
import Surveys from './pages/Surveys';
import AdminLogin from './pages/admin/Login';
import AdminDashboard from './pages/admin/Dashboard';
import AdminUsers from './pages/admin/Users';
import AdminSurveys from './pages/admin/Surveys';
import AdminRewards from './pages/admin/Rewards';
import AdminRewardRequests from './pages/admin/RewardRequests';
import AdminPartnerOffers from './pages/admin/PartnerOffers';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Home />} />
        <Route 
          path="/login" 
          element={
            <AuthGuard requireAuth={false}>
              <Login />
            </AuthGuard>
          } 
        />
        <Route 
          path="/register" 
          element={
            <AuthGuard requireAuth={false}>
              <Register />
            </AuthGuard>
          } 
        />
        <Route 
          path="/forgot-password" 
          element={
            <AuthGuard requireAuth={false}>
              <ForgotPassword />
            </AuthGuard>
          } 
        />
        <Route 
          path="/email-verification" 
          element={<EmailVerification />} 
        />
        <Route 
          path="/email-confirmed" 
          element={<EmailConfirmed />} 
        />
        <Route 
          path="/password-reset-request" 
          element={<PasswordResetRequest />} 
        />
        <Route 
          path="/reset-password" 
          element={<ResetPassword />} 
        />

        {/* Protected user routes */}
        <Route 
          path="/dashboard" 
          element={
            <AuthGuard>
              <Dashboard />
            </AuthGuard>
          } 
        />
        <Route 
          path="/settings" 
          element={
            <AuthGuard>
              <Settings />
            </AuthGuard>
          } 
        />
        <Route 
          path="/rewards" 
          element={
            <AuthGuard>
              <Rewards />
            </AuthGuard>
          } 
        />
        <Route 
          path="/surveys" 
          element={
            <AuthGuard>
              <Surveys />
            </AuthGuard>
          } 
        />

        {/* Admin routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route 
          path="/admin" 
          element={
            <AuthGuard requireAdmin>
              <AdminDashboard />
            </AuthGuard>
          } 
        />
        <Route 
          path="/admin/users" 
          element={
            <AuthGuard requireAdmin>
              <AdminUsers />
            </AuthGuard>
          } 
        />
        <Route 
          path="/admin/surveys" 
          element={
            <AuthGuard requireAdmin>
              <AdminSurveys />
            </AuthGuard>
          } 
        />
        <Route 
          path="/admin/rewards" 
          element={
            <AuthGuard requireAdmin>
              <AdminRewards />
            </AuthGuard>
          } 
        />
        <Route 
          path="/admin/reward-requests" 
          element={
            <AuthGuard requireAdmin>
              <AdminRewardRequests />
            </AuthGuard>
          } 
        />
        <Route 
          path="/admin/partner-offers" 
          element={
            <AuthGuard requireAdmin>
              <AdminPartnerOffers />
            </AuthGuard>
          } 
        />
        
        {/* Catch all route */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      
      <ToastContainer 
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
}

export default App;